import React from "react";
const SvgLoginGoToChronology = props => (
  <svg fill="none" viewBox="0 0 32 32" {...props}>
    <path
      fill="#39434E"
      fillRule="evenodd"
      d="M16 4.5C9.649 4.5 4.5 9.649 4.5 16S9.649 27.5 16 27.5 27.5 22.351 27.5 16 22.351 4.5 16 4.5zM3 16C3 8.82 8.82 3 16 3s13 5.82 13 13-5.82 13-13 13S3 23.18 3 16z"
      clipRule="evenodd"
    />
    <path
      fill="#E4002B"
      fillRule="evenodd"
      d="M16.047 7.75c.69 0 1.25.56 1.25 1.25v6.5a1.25 1.25 0 11-2.5 0V9c0-.69.56-1.25 1.25-1.25z"
      clipRule="evenodd"
    />
    <path
      fill="#E4002B"
      fillRule="evenodd"
      d="M17.018 15.213a1.25 1.25 0 01-.184 1.758l-2.647 2.147a1.25 1.25 0 01-1.574-1.942l2.647-2.147a1.25 1.25 0 011.758.184z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgLoginGoToChronology;
